<template>
  <v-dialog
    :value="show"
    max-width="420px"
    content-class="helmi-search-watch-create-dialog"
    @input="$emit('close')"
  >
    <v-card :id="$attrs.id">
      <v-card-title class="text-h5">
        Hakuvahdin tallennus
      </v-card-title>
      <v-card-text>
        <v-row>
          <helmi-subheader
            icon="person"
            label="Yhteystiedot"
            class="pb-0"
          />
          <v-col>
            <helmi-customer-search :customer="customer"/>
          </v-col>
          <helmi-text-field
            id="name"
            v-model="customer.name"
            :container-options="{
              cols: 12,
            }"
            :color="color"
            :disabled="!!customer.id"
            icon="person"
            label="Nimi"
            dense
            outlined
          />

          <helmi-text-field
            id="email"
            v-model="customer.email"
            :container-options="{
              cols: 12,
            }"
            :color="color"
            icon="email"
            label="Sähköposti"
            dense
            outlined
          />

          <helmi-text-field
            id="phone"
            v-model="customer.phone"
            :container-options="{
              cols: 12,
            }"
            :color="color"
            icon="phone"
            label="Puhelin"
            dense
            outlined
          />
          <v-col cols="12">
            <v-select
              v-model="customer.agent"
              :items="agents"
              item-text="nimi"
              item-value="id"
              label="Hoitaja"
              hide-details
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="grey lighten-5">
        <v-spacer/>
        <v-btn
          id="confirm"
          color="primary"
          text
          :disabled="emptyFields"
          @click="createSearchWatch"
        >
          Tallenna
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { apiGet } from '../../api';

export default {
  name: 'HelmiSearchWatchDialog',

  components: {
    'helmi-text-field': () => import('@/components/formElements/TextField'),
    'helmi-subheader': () => import('@/components/formElements/Subheader'),
    'helmi-customer-search': () => import('@/components/CustomerSearch'),
  },

  props: {
    customer: {
      type: Object,
      default: () => ({
        agent: null,
        name: '',
        email: '',
        phone: '',
      }),
    },

    color: {
      type: String,
      default: 'primary',
    },

    show: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    agents: [],
  }),

  computed: {
    ...mapGetters({
      userDetails: 'userDetails',
    }),
    emptyFields() {
      return (!this.customer.name || !this.customer.phone || !this.customer.email);
    },
  },

  async mounted() {
    const agentResponse = await apiGet('agent/getAgents');
    this.agents = [...agentResponse.result, { nimi: 'Ei valittu', id: null }];
    this.customer.agent = this.agents.find(a => a.nimi === this.userDetails.nimi).id;
  },

  methods: {
    createSearchWatch() {
      this.$emit('save', this.customer);
    },
  },
};
</script>
